import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  user: any;
  loading = false;
  result: any;
  defaultError = 'Something went wrong. Please check your email address and password and try again';
  serverError = '';

  loginForm: FormGroup = this.fb.group({
    email: ['', Validators.compose([Validators.required, Validators.email])],
    password: ['', Validators.required],
    persistent: [false],
  });

  constructor(private auth: AuthService, private route: ActivatedRoute, private fb: FormBuilder) {}

  ngOnInit() {
    if (this.route.snapshot.data.signout) {
      this.auth.signOut().subscribe(a => {
        document.location.href = '/';
      });
    }
  }

  login() {
    if (this.loginForm.invalid) {
      return;
    }
    this.loading = true;

    this.auth.login(this.loginForm.value).subscribe(a => {
      this.result = a;
      if (a.auth) {
        const returnUrl = this.route.snapshot.queryParams.url || '/';
        document.location.href = returnUrl;
      } else {
        // this.loginForm.get('password').setErrors({ error: true });
        this.serverError = this.result.error ? this.result.error : this.defaultError;
      }
      this.loading = false;
    });
  }
}
